<!-- <ng-template [noConnection]="false" [ngStyle]="{ 'z-index': 9 }"></ng-template> -->
<ion-app>
  <ion-router-outlet mode="md"></ion-router-outlet>
  <l4pay-connection-error-modal *noConnection [ngStyle]="{ 'z-index': 9 }"></l4pay-connection-error-modal>
</ion-app>
